import React, { useState, useContext, useEffect, useRef } from 'react';
import openSocket from 'socket.io-client';
import FilterPanel from '../../custom/components/organisms/FilterPanel';
import GridView from '../../custom/components/molecules/ProductCard/GridView';
import './Search.css';
import CustomInput from '../../custom/components/atoms/Inputs/CustomInput';
import CustomSelect from '../../custom/components/atoms/Inputs/CustomSelect';
import { Button } from '@material-ui/core';
import ListView from '../../custom/components/molecules/ProductCard/ListView';
import Drawer from '@material-ui/core/Drawer';
import ProductView from '../../custom/components/organisms/ProductView';
import ProductContext from '../../custom/context/product/productContext';
import AuthContext from '../../custom/context/auth/authContext';
import AlertContext from '../../custom/context/alert/alertContext';
import CommonContext from '../../custom/context/common/commonContext';

import { Pagination } from '@material-ui/lab';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { useFormik } from 'formik';
import { messageHandler } from '../Common/socketHandler';
import { useCustomMediaQuery } from '../../product/common/components';
import SearchSkeleton from './SearchSkeleton';

const useStyles = makeStyles({
  fullList: {
    width: 'auto',
  },
});

const Search = () => {
  const productContext = useContext(ProductContext);
  const authContext = useContext(AuthContext);
  const alertContext = useContext(AlertContext);
  const commonContext = useContext(CommonContext);
  const { searchValue, setSearchValue, clearSearchValue, currentLocation } = commonContext;

  const classes = useStyles();

  const {
    search_allproducts,
    getAllSearchProducts,
    responseStatus,
    addSavedSearch,
  } = productContext;
  const { user } = authContext;
  const { setAlert } = alertContext;

  const [auctionView, setAuctionView] = useState('Grid');
  const [loading, setLoading] = useState(true);

  const [state, setState] = useState({
    right: false,
    bottom: false,
    data: {},
  });
  let [viewProduct, setViewProduct] = useState([]);

  const pageOptions = [
    {
      value: '120',
      show: '120 Results per page',
    },
    {
      value: '240',
      show: '240 Results per page',
    },
    {
      value: '360',
      show: '360 Results per page',
    },
  ];

  const sortShow = [
    {
      value: '(p.score_proj + p.score_price) / 2, desc',
      show: 'Relevant',
    },
    {
      value: 'p.wprice,asc',
      show: 'Current Price (Low - High)',
    },
    {
      value: 'p.wprice,desc',
      show: 'Current Price (High - Low)',
    },
    {
      value: 'p.date_closed,asc',
      show: 'Time remaining',
    },
    {
      value: 1,
      show: 'Ending Today',
    },
    {
      value: 'it.retailPrice,asc',
      show: 'Retail Price (Low - High)',
    },
    {
      value: 'it.retailPrice,desc',
      show: 'Retail Price (High - Low)',
    },
    {
      value: 'bid_count,asc',
      show: 'Bid Count (Low - High)',
    },
    {
      value: 'bid_count,desc',
      show: 'Bid Count (High - Low)',
    },
  ];

  const formik = useFormik({
    initialValues: {
      searchbar: '',
    },
  });

  const [search, setSearch] = useState({
    limit: 120,
    page: 1,
    orderby: '(p.score_proj + p.score_price) / 2, desc',
    order: '',
    filters: {
      category: {
        value: [],
        type: 'array',
        field: 'it.categoryTypeId',
      },
      condition: {
        value: [],
        type: 'array',
        field: 'it.conditionTypeId',
      },
      location: {
        value: [],
        type: 'array',
        field: 'p.location_id',
      },
      price: {
        value:
          searchValue != null && searchValue.filter && searchValue.filters.price.value !== ''
            ? searchValue.filters.price.value
            : 0,
        type: 'range',
        field: 'p.wprice',
      },
      searchbar: {
        value:
          searchValue && searchValue.filters && typeof searchValue.filters.searchbar !== 'undefined'
            ? searchValue.filters.searchbar.value
            : '',
        type: 'like',
        field: 'it.leadDescription',
      },
      auctionlotId: {
        value:
          searchValue && searchValue.filters && typeof searchValue.filters.auctionlotId !== 'undefined'
            ? searchValue.filters.auctionlotId.value
            : [],
        type: 'array',
        field: 'p.auctionlotId',
      },
      starRating: {
        value:
          searchValue &&
          searchValue.filters &&
          typeof searchValue.filters.starRating !== 'undefined'
            ? searchValue.filters.starRating.value
            : [],
        type: 'array',
        field: 'it.starRating',
      },
      currentLocation: {
        state: currentLocation.state,
        city: currentLocation.city,
      },
    },
  });
  const [auctionTitle, setAuctionTitle] = useState(null);
  const searchRef = useRef(search);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setSearch({
        ...search,
        filters: {
          ...search.filters,
          searchbar: {
            ...search.filters.searchbar,
            value: formik.values.searchbar,
          },
        },
      });
    }
  };

  useEffect(() => {
    if (searchValue) {
      if (
        searchValue.filters.category &&
        searchValue.filters.category.value &&
        searchValue.filters.category.value.length > 0
      ) {
        setSearch({
          ...search,
          filters: {
            ...search.filters,
            category: {
              ...search.filters.category,
              value: searchValue.filters.category.value,
            },
          },
        });
      } else if (
        searchValue.filters.condition &&
        searchValue.filters.condition.value &&
        searchValue.filters.condition.value.length > 0
      ) {
        setSearch({
          ...search,
          filters: {
            ...search.filters,
            condition: {
              ...search.filters.condition,
              value: searchValue.filters.condition.value,
            },
          },
        });
      } else if (
        searchValue.filters.location &&
        searchValue.filters.location.value &&
        searchValue.filters.location.value.length > 0
      ) {
        setSearch({
          ...search,
          filters: {
            ...search.filters,
            location: {
              ...search.filters.location,
              value: searchValue.filters.location.value,
            },
          },
        });
      } else if (searchValue.filters.price && searchValue.filters.price.value) {
        setSearch({
          ...search,
          filters: {
            ...search.filters,
            price: {
              ...search.filters.price,
              value: searchValue.filters.price.value,
            },
          },
        });
      } else if (
        searchValue.filters.auctionlotId &&
        searchValue.filters.auctionlotId.value &&
        searchValue.filters.auctionlotId.value.length > 0
      ) {
        setSearch({
          ...search,
          filters: {
            ...search.filters,
            auctionlotId: {
              ...search.filters.auctionlotId,
              value: searchValue.filters.auctionlotId.value,
            },
          },
        });
        setAuctionTitle(searchValue.filters.auctionlotId.title);
      } else if (searchValue.filters.searchbar && searchValue.filters.searchbar.value !== null) {
        setSearch({
          ...search,
          filters: {
            ...search.filters,
            searchbar: {
              ...search.filters.searchbar,
              value: searchValue.filters.searchbar.value,
            },
          },
        });
        formik.values.searchbar = searchValue.filters.searchbar.value;
      } else if (
        searchValue.filters.starRating &&
        searchValue.filters.starRating.value &&
        searchValue.filters.starRating.value.length > 0
      ) {
        setSearch({
          ...search,
          filters: {
            ...search.filters,
            starRating: {
              ...search.filters.starRating,
              value: searchValue.filters.starRating.value,
            },
          },
        });
        formik.values.starRating = searchValue.filters.starRating.value;
      }
    }
  }, [searchValue]);

  useEffect(() => {
    setLoading(true);
    if (searchValue) {
      clearSearchValue();
      if (
        search.filters.category.value.length > 0 ||
        search.filters.condition.value.length > 0 ||
        search.filters.location.value.length > 0 ||
        search.filters.auctionlotId.value.length > 0 ||
        search.filters.searchbar.value !== '' ||
        search.filters.price.value !== ''
      ) {
        getAllSearchProducts(search);
      }
    } else {
      getAllSearchProducts(search);
    }
  }, [search]);

  const locationInitialLoad = useRef(true);
  useEffect(() => {
    if (locationInitialLoad.current === true) {
      locationInitialLoad.current = false;
    } else {
      let searchFilter = { ...search };
      searchFilter.filters.currentLocation = {
        state: currentLocation.state,
        city: currentLocation.city,
      };
      setSearch(searchFilter);
    }
  }, [currentLocation]);

  const onHandlePage = (event, value) => {
    setSearch({ ...search, page: value });
  };
  const initialLoad = useRef(true);

  useEffect(() => {
    if (!initialLoad.current) {
      setLoading(false);
      setViewProduct(search_allproducts.records.length ? search_allproducts.records : []);
    } else {
      initialLoad.current = false;
    }
  }, [search_allproducts]);

  useEffect(() => {
    setViewProduct([]);
    return () => {
      setViewProduct([]);
    };
  }, []);

  const viewProductRef = useRef(viewProduct);
  const userRef = useRef(user);
  useEffect(() => {
    viewProductRef.current = viewProduct;
    userRef.current = user;
    searchRef.current = search;
  });

  const handler = (message, type) => {
    if (type === 'productPosted' || type === 'productClosed' || type === 'cancelBid') {
      setLoading(true);
      getAllSearchProducts(searchRef.current);
    } else {
      messageHandler(
        message,
        viewProductRef.current,
        userRef.current,
        setAlert,
        setViewProduct,
        type
      );
    }
  };

  useEffect(() => {
    if (responseStatus) {
      if (responseStatus.from === 'watchlist') {
        handler(
          { id: responseStatus.data.project_id, status: responseStatus.data.status },
          'watchlistAdded'
        );
      }
    }
  }, [responseStatus]);

  useEffect(() => {
    const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`);
    socket.on('realclosedupdates', (data) => {
      handler(data, 'realclosedupdates');
    });
    socket.on('bidAddtime', (data) => {
      handler(data, 'bidAddtime');
    });
    socket.on('productPosted', (data) => {
      handler(data, 'productPosted');
    });
    socket.on('productClosed', (data) => {
      handler(data, 'productClosed');
    });
    socket.on('cancelBid', (data) => {
      handler(data, 'cancelBid');
    });

    return () => {
      socket.off('realclosedupdates', (data) => {
        handler(data, 'realclosedupdates');
      });
      socket.off('bidAddtime', (data) => {
        handler(data, 'bidAddtime');
      });
      socket.off('productPosted', (data) => {
        handler(data, 'productPosted');
      });
      socket.off('productClosed', (data) => {
        handler(data, 'productClosed');
      });
      socket.off('cancelBid', (data) => {
        handler(data, 'cancelBid');
      });
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (state.right) {
      const index = viewProduct.findIndex((s) => s.id === parseInt(state.data.id, 10));
      if (index !== -1) {
        setState({ ...state, data: viewProduct[index] });
      }
    }
  }, [viewProduct]);

  const toggleDrawer = (anchor, open, data) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (open) {
      setState({ ...state, [anchor]: open, data: data });
    } else {
      setState({ ...state, [anchor]: open, data: {} });
    }
  };

  const clearSearchFilter = () => {
    setSearch({
      ...search,
      limit: 120,
      page: 1,
      orderby: '(p.score_proj + p.score_price) / 2, desc',
      order: '',
      filters: {
        category: {
          ...search.filters.category,
          value: [],
        },
        condition: {
          ...search.filters.condition,
          value: [],
        },
        location: {
          ...search.filters.location,
          value: [],
        },
        price: {
          ...search.filters.price,
          value: '',
        },
        searchbar: {
          ...search.filters.searchbar,
          value: '',
        },
        auctionlotId: {
          ...search.filters.auctionlotId,
          value: [],
        },
        starRating: {
          ...search.filters.starRating,
          value: [],
        },
        currentLocation: {
          city: currentLocation.city,
          state: currentLocation.state,
        },
      },
    });
    setSearchValue({
      filters: {
        category: {
          value: [],
        },
        searchbar: {
          value: '',
        },
      },
    });
    setAuctionTitle(null);
    formik.values.searchbar = '';
  };

  const addSavedSearchData = (search_text) => {
    addSavedSearch({
      search_text: search_text,
      city: currentLocation.city,
      state: currentLocation.state,
    });
  };

  let searchBarValue = searchValue?.filters?.searchbar?.value
    ? searchValue.filters.searchbar.value
    : search.filters.searchbar.value;

  const clearSearchText = () => {
    formik.values.searchbar = '';
    setSearch({
      ...search,
      filters: {
        ...search.filters,
        searchbar: {
          ...search.filters.searchbar,
          value: '',
        },
      },
    });
  };

  const changePageLimit = (value) => {
    setSearch({
      ...searchRef.current,
      limit: value,
    });
  };

  const changeOrder = (value) => {
    setSearch({
      ...searchRef.current,
      orderby: value,
    });
  };

  return (
    <div className="search customContainer">
      <div className="searchCnt d-flex justify-content-start align-items-start">
        <div className="searchLt">
          {searchBarValue && (
            <>
              <p className="mb-0">
                You have searched for <span>&quot;{searchBarValue}&quot;</span>
              </p>
              <Button className="mb-3" onClick={() => addSavedSearchData(searchBarValue)}>
                <span className="material-icons">bookmark_add</span>
                Save this search
              </Button>
            </>
          )}
          <div className="input-group mb-3 searchInput">
            <CustomInput
              inputStyle={{
                backgroundColor: 'white',
                width: '263px',
              }}
              onKeyUp={handleKeyDown}
              name="searchbar"
              onChange={formik.handleChange}
              className="form-control"
              placeholder="Search"
              value={formik.values.searchbar}
              aria-label="Search"
              aria-describedby="searchIcon"
              startAdornment={
                <span className="material-icons" style={{ marginRight: '3px' }}>
                  search
                </span>
              }
              endAdornment={
                <a style={{ cursor: 'pointer' }} onClick={clearSearchText}>
                  <span className="material-icons">close</span>
                </a>
              }
            />
          </div>
          <CustomSelect
            label="Results per page"
            value={search.limit}
            size="small"
            name="limit"
            shrink={search.limit !== '' ? true : false}
            onChange={(event, editor) => {
              setSearch({ ...search, limit: event.target.value });
            }}
          >
            {pageOptions.map((opt, optindex) => (
              <option key={optindex} value={opt.value}>
                {opt.show}
              </option>
            ))}
          </CustomSelect>

          <div className="mt-2 mb-3 gridListToggle">
            <Button
              className={auctionView === 'Grid' ? 'active' : ''}
              onClick={() => setAuctionView('Grid')}
            >
              <i className="fas fa-th-large" /> Grid
            </Button>
            <Button
              className={auctionView === 'List' ? 'active' : ''}
              onClick={() => setAuctionView('List')}
            >
              <i className="fas fa-th-list" />
              List
            </Button>
          </div>

          <div className="mb-4">
            <CustomSelect
              label="Sort By"
              value={search.orderby}
              size="small"
              name="orderby"
              shrink={search.orderby !== '' ? true : false}
              onChange={(event, editor) => {
                setSearch({ ...search, orderby: event.target.value });
              }}
            >
              {sortShow.map((opt, optindex) => (
                <option key={optindex} value={opt.value}>
                  {opt.show}
                </option>
              ))}
            </CustomSelect>
          </div>

          {useCustomMediaQuery('(min-width: 1024px)') ? (
            <div className="deskFilter">
              <FilterPanel
                setSearch={setSearch}
                clearSearch={clearSearchFilter}
                search={search}
                from={1}
              />
            </div>
          ) : (
            <Drawer
              anchor="bottom"
              open={state['bottom']}
              className="responsiveFilterDrawer"
              onClose={toggleDrawer('bottom', false)}
              onOpen={toggleDrawer('bottom', true)}
            >
              <div
                className={clsx(classes.list, 'bottom')}
                role="presentation"
                // onClick={toggleDrawer('bottom', false)}
                onKeyDown={toggleDrawer('bottom', false)}
              >
                <div>
                  <h4 class="sbTitle">Sort By</h4>
                  <div class="searchAuctions">
                    <div class="d-flex justify-content-start align-items-center flex-wrap">
                      {sortShow.map((opt, optindex) => (
                        <Button
                          key={optindex}
                          className={search.orderby === opt.value ? 'active' : null}
                          onClick={(event, editor) => {
                            changeOrder(opt.value);
                          }}
                        >
                          {opt.show}
                        </Button>
                      ))}
                    </div>
                  </div>
                  <h4 class="sbTitle">Results Per Page</h4>
                  <div class="searchAuctions">
                    <div class="d-flex justify-content-start align-items-center flex-wrap">
                      {pageOptions.map((opt, optindex) => (
                        <Button
                          key={optindex}
                          className={search.limit === opt.value ? 'active' : null}
                          onClick={(event, editor) => {
                            changePageLimit(opt.value);
                          }}
                        >
                          {opt.show}
                        </Button>
                      ))}
                    </div>
                  </div>
                </div>
                <FilterPanel
                  setSearch={setSearch}
                  clearSearch={clearSearchFilter}
                  search={search}
                  from={1}
                />
              </div>
            </Drawer>
          )}
        </div>

        <div className="searchRt">
          <div className="d-flex justify-content-between align-items-center">
            <div className="sectionTitle w-100">
              <div className="w-100 d-flex justify-content-between align-items-center">
                <h2 className="mb-3">
                  {auctionTitle
                    ? auctionTitle
                    : currentLocation.city + ', ' + currentLocation.state}
                </h2>

                <Button
                  className="toggleRespDrawer"
                  variant="outlined"
                  onClick={toggleDrawer('bottom', true)}
                >
                  <span className="material-icons">tune</span>Filters
                </Button>
              </div>
              <div className="searchInfo d-flex justify-content-start align-items-center">
                <h6>
                  {search.filters.searchbar.value && search.filters.searchbar.value !== ''
                    ? `Search: ${search.filters.searchbar.value}`
                    : 'All Items'}
                </h6>
                {viewProduct.length ? (
                  <h6>{search_allproducts.totalRecords} Results Found</h6>
                ) : null}
              </div>
            </div>
          </div>
          {loading ? (
            <SearchSkeleton />
          ) : (
            <>
              {viewProduct.length ? (
                <div className="searchResults d-flex justify-content-start flex-wrap">
                  <Drawer
                    className="rightDrawer"
                    anchor={'right'}
                    open={state['right']}
                    onClose={toggleDrawer('right', false)}
                  >
                    <ProductView data={state.data} drawerHandler={toggleDrawer('right', false)} />
                  </Drawer>

                  {viewProduct.map((data, index) =>
                    auctionView === 'Grid' ? (
                      <GridView
                        key={index}
                        data={data}
                        favId={`searchProd_${index}`}
                        drawerHandler={toggleDrawer('right', true, data)}
                      />
                    ) : (
                      <ListView
                        key={index}
                        data={data}
                        favId={`searchProd_${index}`}
                        drawerHandler={toggleDrawer('right', true, data)}
                      />
                    )
                  )}

                  <div className="d-flex justify-content-between align-items-center flex-wrap w-100 mb-3 pagination-wrapper">
                    <h6>
                      Showing {search_allproducts.setDisp} of {search_allproducts.totalRecords}
                    </h6>
                    <Pagination
                      count={Math.ceil(search_allproducts.totalRecords / search.limit)}
                      page={search.page}
                      onChange={onHandlePage}
                      siblingCount={3}
                      showFirstButton
                      showLastButton
                      boundaryCount={2}
                    />
                  </div>
                </div>
              ) : (
                <div className="np-pro-box">
                  <img src="./assets/svg/noResults.svg" alt="No results image" />
                  <h5>No Records Found!</h5>
                  <h6>
                    We couldn't find what you are looking for.
                    <br /> You can try changing the filters or come back later.
                  </h6>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* PRODUCT VIEW DRAWER */}
    </div>
  );
};
export default Search;
